/**
 * Табличный вид графика и его выгрузка в CSV. Табличный вид — «доступный двойник» каждого графика:
 * всё, что есть в подсказке, можно прочитать и скопировать без наведения мыши.
 */

export interface ChartTableColumn {
  key: string
  label: string
  align?: 'left' | 'right'
  /** Как показать значение в таблице и в CSV (по умолчанию — как есть, пусто — «—»). */
  format?: (value: unknown, row: Record<string, unknown>) => string
  /** Моноширинный шрифт (артикулы, коды). */
  mono?: boolean
}

export interface ChartTableData {
  columns: ChartTableColumn[]
  rows: Array<Record<string, unknown>>
}

export function cellText(column: ChartTableColumn, row: Record<string, unknown>): string {
  const value = row[column.key]
  if (column.format) return column.format(value, row)
  if (value === null || value === undefined || value === '') return '—'
  return String(value)
}

function csvEscape(value: string): string {
  return /[";\n\r]/.test(value) ? `"${value.replace(/"/g, '""')}"` : value
}

/**
 * CSV для Excel с русской локалью: разделитель «;», BOM в начале, переводы строк CRLF.
 * Значения — в том виде, в каком они показаны в таблице (с единицами и «—» для пустых).
 */
export function toCsv(table: ChartTableData, context?: string): string {
  const header = [...table.columns.map((column) => csvEscape(column.label)), ...(context ? ['Контекст'] : [])].join(';')
  const lines = table.rows.map((row) => [...table.columns.map((column) => csvEscape(cellText(column, row))), ...(context ? [csvEscape(context)] : [])].join(';'))
  return `﻿${[header, ...lines].join('\r\n')}\r\n`
}

/** Имя файла без запрещённых символов. */
export function safeFileName(name: string): string {
  const cleaned = name.replace(/[\\/:*?"<>|]+/g, ' ').replace(/\s+/g, ' ').trim()
  return cleaned || 'chart'
}

export function downloadCsv(fileName: string, table: ChartTableData, context?: string): void {
  const blob = new Blob([toCsv(table, context)], { type: 'text/csv;charset=utf-8' })
  const url = URL.createObjectURL(blob)
  const link = document.createElement('a')
  link.href = url
  link.download = `${safeFileName(fileName)}.csv`
  document.body.appendChild(link)
  link.click()
  link.remove()
  setTimeout(() => URL.revokeObjectURL(url), 0)
}
